<template>
<div class="container-full-width default-container p-3">
    <filtro
        :showfiltro="showfiltro"
        :params="paramsFiltro" 
        @change="filtroChange"
        @cancel="handleCloseFiltro"
    />

    <div class="row">
        <div class="col-12 mb-2">
            <span class="lbl-deal-title mb-2 w-100">CARTEIRA DE CLIENTES</span>
            <v-button label="Retornar para visões" icon="fa-bar-chart" class="float-right" @click="clickRetornar"></v-button>
        </div>
    </div>
    <hr>
    <div class="row mb-3 align-items-center">
        <div class="col-md-auto">
            <div class="d-flex align-items-center">
                <!-- <div class="mr-2">Referência</div> -->
                <!-- <form-field ref="data" v-model="data_referencia" type="date"></form-field> -->
                <form-field ref="data" v-model="data_referencia" type="date" col="12" label="Referência"></form-field>
            </div>
        </div>
        <div class="col-md-6 col-12">
            <v-button label="Filtro" :success="true" @click="handleShowFiltro"></v-button>
        </div>
    </div>

    <div class="row" v-if="chartValues.length > 0">
        <div class="col-md-3 col-12 p-3">
            <span class="lbl-title mb-2">Quantidade de Clientes</span>
            <div class="p-4" style="border-top: 1px solid #dee2e6 !important; background: #fafafa">
                <div class="resumo__performance my-4" v-for="(row, index) in grafico" :key="index">
                    <span class="lbl-data mr-2">{{ row.label }}</span>
                    <span class="resumo__performance__value">{{ row.value }}</span>
                </div>
            </div>
        </div>
        <div class="col-md-9 col-12 p-3">
            <div class="lbl-title mb-2">Gráfico</div>
            <div class="border">
                <chart :params="paramsChart"></chart> 
            </div>
        </div>
    </div>

    <hr>

    <div class="row">
        <div class="col-12 lbl-title mb-2">
            CLIENTES
            <v-button label="Excel" class="float-right" @click="loadData(true)"></v-button>
            <!-- <v-button label="Imprimr" class="float-right"></v-button> -->
        </div>
    </div>

    <div class="row mb-5">
        <div class="col-12">
            <div style="width: 100%; max-height: 100%; overflow: hidden; font-size: 12px">
                <div style="overflow: auto">

                    <table id="relatorio" class="table table-striped table-hover responsive tablesorter w-100">
                        <thead>
                            <tr style="height: 37px">
                                <th class="textual header" style="width:15%" title="">Cliente</th>
                                <th class="textual header" style="width:10%" title="">Status</th>
                                <th class="textual header" style="width:2%" title="">Estado</th>
                                <th class="textual header" style="width:10%" title="">Segmento</th>
                                <th class="textual header" style="width:2%" title="">Nr Pedido</th>
                                <th class="textual header" style="width:6%" title="">Data Último Pedido</th>
                                <th class="numerico header" style="width:6%" title="">Total do Pedido</th>
                                <th class="numerico header" style="width:6%" title="">Nr Dias</th>
                                <th class="textual header" style="width:10%" title="">Telefone</th>
                                <th class="textual header" style="width:10%" title="">Email</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="clientes.length == 0">
                                <td class="textual">Nenhum cliente encontrado</td>
                                <td class="textual"></td>
                                <td class="textual"></td>
                                <td class="textual"></td>
                                <td class="textual"></td>
                                <td class="textual"></td>
                                <td class="textual"></td>
                                <td class="numerico"></td>
                                <td class="numerico"></td>
                                <td class="textual"></td>
                                <td class="textual"></td>
                            </tr>
                            <tr v-else style="height: 37px" v-for="(row, index) in clientes" :key="index">
                                <td class="textual">{{ row.nome }} {{ row.cnpjcpf | formatCNPJCPF }}</td>
                                <td class="textual"><span :class="statusColor(row.dias_ultimo_pedido)"> {{ row.status }} </span></td>
                                <td class="textual">{{ row.uf }}</td>
                                <td class="textual">{{ row.segmento }}</td>
                                <td class="textual">{{ row.npedido }}</td>
                                <td class="textual">{{ row.data_pedido | formatData }}</td>
                                <td class="numerico">{{ row.total_pedido | formatValue(2) }}</td>
                                <td class="numerico">{{ row.dias_ultimo_pedido }}</td>
                                <td class="textual">{{ row.telefone | formatFone }}</td>
                                <td class="textual">{{ row.email }}</td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    </div>


</div>

</template>

<script>
import DashCard from '../dashboards/dash-card'
import Chart from './chart'
import Filtro from './filtro'
import { apiORDSpost } from '../shared/api-functions'
import { apiDownload2 } from '../shared/api-functions'

export default {

    components: {
        DashCard, Filtro, Chart
    },

    data () {
        return {
            showfiltro: false,

            dados: {},

            data_referencia: null,

            //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
            paramsFiltro: {
                filtros: [
                    // { nome: 'filial', label: null, url: null, varios: false, values: [] },
                    { nome: 'segmento', label: null, url: null, varios: true, values: [] },
                    { nome: 'grupocliente', label: null, url: null, varios: true, values: [] },
                    { nome: 'usuario', label: null, url: null, varios: true, values: [] },
                ],
            },

            filtro: {
                periodos: [
                    { data_inicio: null, data_termino: null }
                ]
            },

        }
    },

    watch: {
        data_referencia: function () {
            this.loadData()
        },
    },

    methods: {
        handleCloseFiltro(){
            this.showfiltro = false
        },
        clickRetornar () {
            this.$router.push('/')
        },

        statusColor(dias) {
            if (dias > 365) 
              return 'badge badge-red'
            else
            if (dias > 120) 
              return 'badge badge-yellow'
            else
              return 'badge badge-green'
        },

        handleShowFiltro () {
            this.showfiltro = true
        },

        filtroChange (filtro) {

            this.showfiltro = false

            this.filtro = filtro

            this.paramsFiltro.filtros[0].values = this.filtro.segmento
            this.paramsFiltro.filtros[1].values = this.filtro.grupocliente
            this.paramsFiltro.filtros[2].values = this.filtro.usuario

            this.loadData()

        },

        async loadData (excel) {
            let url = 'consulta/vendas/carteiraclientes'

            this.filtro.excel = excel
            this.filtro.data_referencia = this.data_referencia

            if (excel)
               apiDownload2(this, url, this.filtro, 'post')
            else {
                const data = await apiORDSpost(this.$store, url, this.filtro, 'post')
                if (data) {
                    this.dados = data
                } else {
                    this.dados = {}
                }
            }
        },

    },

    computed: {
        clientes: function () {
            if (!this.dados.clientes)
                return []
            else
                return this.dados.clientes
        },

        grafico: function () {
            if (!this.dados.grafico)
                return []
            else
                return this.dados.grafico
        },

        paramsChart: function () {
            return { chart: { type: 'PieChart' }, values: this.chartValues }
            // return { chart: { type: 'AreaChart' }, values: this.chartValues }
            // return { chart: { type: 'ColumnChart' }, values: this.chartValues }
        },

        chartValues: function () {
            if (!this.grafico)
              return []
            else
              return this.grafico
            // if (!this.grafico || this.grafico.length == 0)
            //   return []

            // let values = [ ['', 'Quantidade de Clientes'] ]

            // for (var x = 0; x < this.grafico.length; x++) {
            //     if (this.grafico[x].label != 'Nunca Comprou')
            //       values.push([ this.grafico[x].label, this.grafico[x].value ])
            // }

            // return values
        },

    },

    mounted () {
        this.$nextTick(function () {
            this.$refs.data.focus()
        })
    },

    created () {
        this.data_referencia = this.$lastDay(this.$getDate())

        if (this.$route.query.usuario) {
            this.filtro.usuario = [this.$route.query.usuario]
            this.paramsFiltro.filtros[2].values = [ this.filtro.usuario ]
        }

        if (this.$route.query.data_inicio) {
            this.data_referencia = this.$route.query.data_inicio
        }

        this.loadData()
    }

}

</script>

<style>

table .numerico {
    min-width:65px; 
    text-align: right;
}

.consulta__total {
    display: flex; 
    align-items: center; 
    justify-content: center
}

.consulta__total_valor {
    font-size: 40px; 
    display: block; 
    line-height: normal;
}

.consulta__cifrao {
    font-size: 16px; 
    display: block; 
    line-height: normal;
}

</style>



// WEBPACK FOOTER //
// src/consultas/consulta-carteira-clientes.vue